<template lang="pug">
  span.security-code-rules
    b-button.btn.btn-outline-info.btn-info.btn-sm(
      type="button"
      :style="buttonStyle"
      :title="$t('ui.security_code_rules')"
      :aria-label="$t('ui.security_code_rules')"
      @click="show = true"
    )
      i.fa.fa-info-circle(aria-hidden="true")
    b-modal(
      v-model="show"
      :title="$t('ui.security_code_rules')"
      centered
      no-fade
      hide-footer
      size="md"
      header-bg-variant="info"
      header-text-variant="light"
    )
      p.mb-2 {{ $t("ui.security_code_rules_intro") }}
      ul.mb-0
        li {{ $t("message.security_code_error") }}
        li {{ $t("message.security_digit_error") }}
        li {{ $t("message.security_consecutive_error") }}
        li {{ $t("message.security_code_example") }}
</template>

<script>
export default {
  name: "SecurityCodeRules",
  props: {
    buttonStyle: {
      type: String,
      default:
        "border-top-left-radius: 0;border-bottom-left-radius: 0;border-top-right-radius: 3px;border-bottom-right-radius: 3px;"
    }
  },
  data() {
    return {
      show: false
    };
  }
};
</script>